import { serviceGet } from "./api";

export function convertTo12HourFormat(time24) {
  const [hours24, minutes, seconds] = time24.split(":");
  let period = "AM";
  let hours12 = parseInt(hours24, 10);

  if (hours12 >= 12) {
    period = "PM";
    if (hours12 > 12) {
      hours12 -= 12;
    }
  } else if (hours12 === 0) {
    hours12 = 12;
  }

  const formattedTime = `${hours12}:${minutes} ${period}`;
  return formattedTime;
}

// Function to get the browser, version, and operating system from the user agent string
export const getDeviceInfo = (userAgent) => {
  let browser;
  let version;
  let os;

  // Detect Browser and Version
  if (userAgent?.includes("Chrome")) {
    browser = "Chrome";
    version = userAgent?.match(/Chrome\/([\d.]+)/)?.[1];
  } else if (userAgent?.includes("Firefox")) {
    browser = "Firefox";
    version = userAgent?.match(/Firefox\/([\d.]+)/)?.[1];
  } else if (userAgent?.includes("Safari") && !userAgent.includes("Chrome")) {
    browser = "Safari";
    version = userAgent?.match(/Version\/([\d.]+)/)?.[1];
  } else if (userAgent?.includes("Edge")) {
    browser = "Edge";
    version = userAgent?.match(/Edg\/([\d.]+)/)?.[1];
  } else if (userAgent?.includes("Opera") || userAgent.includes("OPR")) {
    browser = "Opera";
    version = userAgent?.match(/OPR\/([\d.]+)/)?.[1];
  } else if (userAgent?.includes("Trident") || userAgent.includes("MSIE")) {
    browser = "Internet Explorer";
    version = userAgent?.match(/(MSIE |rv:)([\d.]+)/)?.[2];
  } else {
    browser = "Unknown Browser";
    version = "Unknown Version";
  }

  // Detect Operating System
  if (userAgent?.includes("Windows")) {
    os = "Windows";
  } else if (
    userAgent?.includes("Macintosh") ||
    userAgent?.includes("Mac OS X")
  ) {
    os = "Mac OS";
  } else if (userAgent?.includes("Linux")) {
    os = "Linux";
  } else if (userAgent?.includes("Android")) {
    os = "Android";
  } else if (userAgent?.includes("iPhone") || userAgent?.includes("iPad")) {
    os = "iOS";
  } else {
    os = "Unknown OS";
  }

  // Return a single string combining the browser, version, and OS
  return `${browser} (${version}) on ${os}`;
};

export const getCsrfToken = async () => {
  let csrfToken = localStorage.getItem("csrfToken");

  if (!csrfToken) {
    try {
      const csrfTokenRes = await serviceGet("csrf-token", {
        withCredentials: true,
      });
      csrfToken = csrfTokenRes.csrfToken;
      localStorage.setItem("csrfToken", csrfToken);
    } catch (error) {
      console.error("Error fetching CSRF token:", error);
    }
  }

  return csrfToken;
};
